export default __webpack_public_path__ + "static/media/review-course.723c5899.svg";